import { object } from 'yup';
import formsBaseActionProductValidation from './base-action-product';

const formsActionValidation = object().shape({
  ...formsBaseActionProductValidation,
});

export default formsActionValidation;
